import { TransactionForReconciliationFromStatement } from "../../common/contracts/reconciliation.contract";

export function getStatmentTransactionId(
    statementTransaction: TransactionForReconciliationFromStatement,
) {
    return `${statementTransaction.financialDocumentId}-${statementTransaction.row}`;
}
